/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountRead } from '../models/AccountRead';
import type { AccountSetupRequest } from '../models/AccountSetupRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AccountService {
    /**
     * Setup
     * Provision the signed-in Firebase user: account + brand + first contact + credits.
     *
     * Idempotent enough to resume a half-finished signup: an account with no brand
     * gets its brand here. An account that already has one is a 409.
     * @param requestBody
     * @returns AccountRead Successful Response
     * @throws ApiError
     */
    public static setup(
        requestBody: AccountSetupRequest,
    ): CancelablePromise<AccountRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/accounts/setup',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Me
     * The signed-in account, with its plan and brands. 404 until setup has run.
     * @returns AccountRead Successful Response
     * @throws ApiError
     */
    public static me(): CancelablePromise<AccountRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/accounts/me',
        });
    }
}
